import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";
import type { AboutDto } from "$src/core/models/dto";

const queryKey = () => ["about"];

const useAboutQuery = (
  options?: Omit<UseQueryOptions<Awaited<AboutDto>>, "queryKey" | "queryFn">,
) => {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKey(),
    queryFn: () => api.getAbout(),
    ...options,
  });
};

export default useAboutQuery;
